// Home.js
import React, { useEffect, useState } from "react";
import TravelForm from "../component/TravelForm";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import pako from "pako";
import TravelPreviewPage from "./TravelPreviewPage";

function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();
  const [previewData, setPreviewData] = useState(null);

  const decompressText = (base64String) => {
    try {
      const compressedBytes = Uint8Array.from(atob(base64String), (c) =>
        c.charCodeAt(0)
      );
      const utf8Bytes = pako.ungzip(compressedBytes);
      const decodedText = new TextDecoder().decode(utf8Bytes);
      return JSON.parse(decodedText);
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const travelDataBase64 = params.get("travelData");

    if (travelDataBase64) {
      const decompressedData = decompressText(travelDataBase64);
      if (decompressedData) {
        setPreviewData(decompressedData);
      } else {
        setPreviewData(null);
      }
    } else {
      setPreviewData(null);
    }
  }, [location.search]);

  // travelData パラメータがある場合はURLを変えずにプレビューを表示
  if (previewData) {
    return <TravelPreviewPage travelDataFromUrl={previewData} />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
        p: 2,
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          color: "#fff",
          mb: isMobile ? 2 : 4,
        }}
      >
        <Typography variant="h3" fontWeight="bold" sx={{ mb: 1 }}>
          旅ジョーズ
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.8, mb: 2 }}>
          思い出に残る旅の計画を始めましょう！
        </Typography>
        既にデータをお持ちの方は
        <Typography
          component="span"
          onClick={() => navigate("/tabi-jaws/data")}
          sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
        >
          こちら
        </Typography>
      </Box>
      <TravelForm />
    </Box>
  );
}

export default Home;
